export enum OperationStatus {
  NULL = '',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  APPROVED = "APPROVED",
  DENIED = 'DENIED',
  WAITING = "WAITING",
  CREATED = "CREATED",
  CONFIRMING = 'CONFIRMING',
  CONFIRMED = 'CONFIRMED',
  WAITINGTHEBANK = "WAITING THE BANK",
  WAITINGORGANIZATTION = "WAITING ORGNAIZATION"
}